module.exports = __webpack_public_path__ + "media/images/img_facebook-7a939ca1ed9863768e56599539e5ad13.png";